import FormAnalytics from '../formAnalytics/formAnalytics'
import { FormNames } from '../formAnalytics/formEvents.types'
import { PortalProducts } from '../types/analytics.type'

import { Settings } from './userSettingsAnalytics.types'

class UserSettingsAnalytics extends FormAnalytics {
  public constructor() {
    super(PortalProducts.ACCOUNT, FormNames.USER_SETTING)
  }

  public logSaveSettings(tabName: string): void {
    this.logEvent({
      event: Settings.SAVE_SETTINGS,
      title: tabName,
    })
  }

  public logRevertSetting(tabName: string): void {
    this.logEvent({
      event: Settings.REVERT_SETTINGS,
      title: tabName,
    })
  }
}

export default new UserSettingsAnalytics()
